import classNames from 'classnames';

import style from './SupportWidget.module.scss';

import type { SupportTicketStatusFields, SupportTicketStatusGroup } from 'chaika-frontend-types/frontend-cms';

import { translate } from '@chaika/i18n/helper';

const STATUS_GROUP_CLASS_NAMES: Record<SupportTicketStatusGroup, string> = {
    to_do: style.ticketStatusToDo,
    in_progress: style.ticketStatusInProgress,
    complete: style.ticketStatusComplete,
};

export function TicketStatusBadge({ ticket }: { ticket: SupportTicketStatusFields }) {
    const isDeleted = ticket.status === 'deleted';

    if (isDeleted) {
        return (
            <span className={classNames(style.ticketStatus, style.ticketStatusDeleted)}>
                {translate('supportStatusDeleted')}
            </span>
        );
    }

    return (
        <span
            className={classNames(
                style.ticketStatus,
                ticket.statusGroup && STATUS_GROUP_CLASS_NAMES[ticket.statusGroup],
            )}
        >
            {ticket.statusName}
        </span>
    );
}
